import React, { useMemo } from 'react';
import NotesEditor from '../../../../shared/Notes/NotesEditor';
import { ProfilesTabParamList, useGoBack, useNotesTabNavigation } from '../../../../../utils/appNavigationNames';
import { useEditNote } from '../../../../../hooks/api/useNotes';
import { RouteProp } from '@react-navigation/native';
import { NoteDestination, noteDetailsToDestination } from '../../../../shared/Notes/utils/types';
import { useConfirmBackNavigationOnDirtyForm } from '../../../../shared/FormExitValidation';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';
import { View } from 'react-native';

export type EditClientRecordNoteScreenOwnProps = {};

export type EditClientRecordNoteScreenProps = EditClientRecordNoteScreenOwnProps & {
    route: RouteProp<ProfilesTabParamList, 'edit-client-record-note'>;
};

const EditClientRecordNoteScreen: React.FC<EditClientRecordNoteScreenProps> = (props) => {
    const goBack = useGoBack();
    const navigator = useNotesTabNavigation();
    useConfirmBackNavigationOnDirtyForm(navigator);
    const { note, isLoadingNote, isUpdatingUserNote, noteEditorProps, key } = useEditNote({
        noteId: props.route.params.noteId,
        onUpdateSuccess: () => {
            goBack();
        },
    });

    const noteDestination = useMemo<NoteDestination | null>(
        () => (note ? noteDetailsToDestination(note) : null),
        [note],
    );

    return (
        <AnimateLoadedContent isLoading={!note || isLoadingNote || !noteDestination || isUpdatingUserNote}>
            {() => (
                <View style={{ width: '100%', height: '100%' }}>
                    <NotesEditor
                        key={key}
                        source="profiles.edit-client-record-note-route"
                        onCancel={goBack}
                        isDisabled={isUpdatingUserNote}
                        note={note!}
                        noteDestination={noteDestination!}
                        disableRecording
                        {...noteEditorProps}
                    />
                </View>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(EditClientRecordNoteScreen);
